import React, { ReactElement } from "react"
import Dialog from "material-ui/Dialog"
import FlatButton from "material-ui/FlatButton"
import strings from "../../localization/strings"
interface IProps {
  open: boolean
  action?: string
  confirmContent: string
  close(): void
  confirm(action: string, payload: any): void
  title?: string
  payload?: any
  subContext?: ReactElement
  confirmBtnLabel?: string
  cancelBtnLabel?: string
}

const ConfirmDialog: React.SFC<IProps> = (props: IProps) => {
  const actions = [
    <FlatButton
      data-intercom-target={"Btn-CloseConfirmDialog"}
      label={props.cancelBtnLabel || strings.CANCEL}
      primary={false}
      onClick={props.close}
    />,
    <FlatButton
      data-intercom-target={"Btn-ConfirmAction"}
      label={props.confirmBtnLabel || strings.OK}
      primary={true}
      keyboardFocused={true}
      onClick={() => props.confirm(props.action, props.payload)}
    />,
  ]

  return (
    <div>
      <Dialog
        title={props.title ? props.title : strings.Confirm_Dialog}
        actions={actions}
        modal={true}
        open={props.open}
        onRequestClose={() => props.confirm(props.action, props.payload)}
      >
        <div dangerouslySetInnerHTML={{ __html: props.confirmContent }} />
        {props.subContext &&
          <div>
            {React.cloneElement(props.subContext)}
          </div>
        }
      </Dialog>
    </div>
  );
}

export default ConfirmDialog